var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.417 5.24805C22.1132 5.70326 23.6598 6.59661 24.9016 7.83844C26.1434 9.08026 27.0368 10.6269 27.492 12.323",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3794 9.11133C20.3995 9.38226 21.3299 9.91806 22.0763 10.6644C22.8227 11.4108 23.3585 12.3412 23.6294 13.3613",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0544 15.8471C13.0835 17.9721 14.8018 19.686 16.9294 20.7096C17.0864 20.7839 17.26 20.8161 17.4331 20.8029C17.6063 20.7898 17.773 20.7318 17.9169 20.6346L21.0419 18.5471C21.18 18.4535 21.3396 18.3963 21.5057 18.381C21.6718 18.3657 21.8391 18.3928 21.9919 18.4596L27.8419 20.9721C28.0419 21.0553 28.2089 21.202 28.3173 21.3894C28.4258 21.5769 28.4695 21.7948 28.4419 22.0096C28.2565 23.4568 27.5502 24.7868 26.455 25.7508C25.3598 26.7148 23.9509 27.2468 22.4919 27.2471C17.9833 27.2471 13.6592 25.456 10.4711 22.2679C7.28301 19.0798 5.49194 14.7558 5.49194 10.2471C5.49227 8.78811 6.02421 7.37921 6.98823 6.28406C7.95224 5.1889 9.28227 4.48253 10.7294 4.29711C10.9442 4.26952 11.1622 4.3133 11.3496 4.42172C11.5371 4.53014 11.6837 4.69717 11.7669 4.89711L14.2794 10.7596C14.3448 10.91 14.3721 11.0742 14.359 11.2377C14.346 11.4012 14.2929 11.559 14.2044 11.6971L12.1169 14.8721C12.024 15.0157 11.9695 15.1808 11.9585 15.3515C11.9476 15.5222 11.9806 15.6928 12.0544 15.8471Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.dd915d420e9c51d5aa46855ecbabae5d.svg";
export { ForwardRef as ReactComponent };